export const subcontractorsSliceName = "subcontractors"
